var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-content",on:{"click":function($event){return _vm.choose()}}},[_c('div',{staticClass:"hot-data"},_vm._l((_vm.hot_list),function(item,index){return _c('div',{key:index,staticClass:"hot-item",class:[{'move': _vm.isMove}],style:(("top: -" + (9.06667*_vm.hotIndex) + "vw"))},[_vm._v(_vm._s(item.hotWord))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cffa2392","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/hotSwiper.vue
// module id = null
// module chunks = 